module.exports = __webpack_public_path__ + "img/no_zone.f100ed06.svg";